module.exports = __webpack_public_path__ + "static/media/ViciousCycles.949f4d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ViciousCycles.png
// module id = 52
// module chunks = 0